<template>
  <div
    class="card-container password-recovery-container visit-cancellation"
    :class="{ 'change-password' : !!token }"
  >
    <template v-if="token && !checkedToken && mode !== 'confirmed'">
      <div class="spinner-container">
        <spinner v-if="!errorMsg" />
        <p
          class="text error-text"
          v-else
        >
          {{ errorMsg }}
        </p>
      </div>
    </template>
    <form
      @submit.prevent="onSubmit"
      v-else
    >
      <template v-if="mode !== 'confirmed'">
        <form @submit.prevent="onSubmit">
          <standard-input
            type="textarea"
            :rows="5"
            :value="comment"
            @input_change="onInput($event)"
            @input_focus="inputFocus = true"
            @input_blur="inputFocus = false"
            label="Dlaczego musisz odwołać wizytę?"
          />
          <div class="cancel-buttons-wrapper">
            <standard-button
              :background-color="primaryColor"
              text-color="white"
              custom-class="cancel-visit-button"
              type="submit"
              :loading="loading"
              text="Potwierdzam odwołanie wizyty"
            />
            <standard-button
              class-type="secondary"
              text="Anuluj"
              custom-class="cancel-visit-button"
              @buttonClick="toggleModal()"
              :text-color="primaryColor"
            />
          </div>
        </form>
      </template>
      <p
        class="text error-text"
        v-else
      >
        Wizyta została odwołana.
      </p>
    </form>
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';
import config from '@/config';
import ajax from '@/helpers/ajax';
import Spinner from 'vue-simple-spinner';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    Spinner,
    StandardButton,
    StandardInput,
  },
  data() {
    return {
      token: null,
      checkedToken: false,
      errorMsg: '',
      isVisitCanceled: false,
      loading: false,
      comment: '',
      visit: null,
      mode: '',
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
    }),
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/closeModal',
    }),
    checkAccess() {
      const params = {
        token: this.token,
      };

      ajax.get(config.apiEndpoints.cancelVisit, { params })
        .then((res) => {
          if (res.status === 200) {
            this.checkedToken = true;
            this.visit = res.data;
          }
        })
        .catch((error) => {
          this.errorMsg = error.response.data.message;
        });
    },
    onInput(value) {
      this.comment = value;
    },
    onSubmit() {
      this.loading = true;

      const data = {
        token: this.token,
        comment: this.comment,
      };

      ajax.delete(config.apiEndpoints.cancelVisit, { data })
        .then((res) => {
          if (res.status === 200) {
            this.mode = 'confirmed';
          }
          this.loading = false;
        })
        .catch((error) => {
          this.mode = 'error';
          console.error(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.access_token) {
      this.token = this.$route.params.access_token;
      this.checkAccess();
    }
  },
};
</script>
